<template>
  <!-- <v-sheet color="grey lighten-4 width-100 height-100 pa-4" rounded> -->
    <!-- <div class="d-flex flex-column height-100"> -->
      <!-- <div class="mb-2 d-flex align-center"> -->
        <!-- <h3 class="text-subtitle-1 font-weight-medium mr-3 mb-0">Code Editor</h3> -->
        <!-- <v-select
          v-model="language"
          :items="languages"
          label="Language"
          dense
          outlined
          hide-details
          class="language-selector"
        ></v-select>
        <v-spacer></v-spacer>
        <v-btn v-if="!readOnly" small color="primary" @click="saveCode">Save</v-btn>
        <v-chip v-else small color="grey lighten-2" class="black--text">Read-only • Use chat to request changes</v-chip>
      </div> -->

      <div ref="editorContainer" class="flex-grow-1 editor-container" style="min-height: 400px;">
        <!-- Monaco editor will be mounted here -->
      </div>
    <!-- </div> -->
  <!-- </v-sheet> -->
</template>

<script>
import * as monaco from 'monaco-editor';
import loader from '@monaco-editor/loader';

export default {
  name: 'GameCode',
  props: {
    game: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      code: '',
      language: 'javascript',
      languages: [
        { text: 'JavaScript', value: 'javascript' },
        { text: 'TypeScript', value: 'typescript' },
        { text: 'HTML', value: 'html' },
        { text: 'CSS', value: 'css' },
        { text: 'JSON', value: 'json' },
        { text: 'Python', value: 'python' }
      ],
      editor: null,
      monacoInstance: null
    };
  },
  mounted() {
    this.initializeCode();
    this.initializeEditor();
    window.addEventListener('resize', this.resizeEditor);
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.dispose();
    }
    window.removeEventListener('resize', this.resizeEditor);
  },
  methods: {
    initializeCode() {
      // Handle different possible structures of game.codebase
      if (typeof this.game.codebase === 'string') {
        this.code = this.game.codebase;
      } else if (this.game.codebase && typeof this.game.codebase.code === 'string') {
        this.code = this.game.codebase.code;
      } else if (this.game.codebase && typeof this.game.codebase === 'object') {
        this.code = JSON.stringify(this.game.codebase, null, 2);
      } else {
        this.code = '';
      }
    },
    async initializeEditor() {
      try {
        // Load Monaco
        this.monacoInstance = await loader.init();
        
        // Create editor
        this.editor = this.monacoInstance.editor.create(this.$refs.editorContainer, {
          value: this.code,
          language: this.language,
          theme: 'vs-dark',
          automaticLayout: true,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          fontSize: 14,
          wordWrap: 'on',
          lineNumbers: 'on',
          tabSize: 2,
          readOnly: this.readOnly
        });

        // Add change event listener
        this.editor.onDidChangeModelContent(() => {
          this.code = this.editor.getValue();
        });
      } catch (error) {
        console.error('Failed to initialize Monaco editor:', error);
      }
    },
    resizeEditor() {
      if (this.editor) {
        this.editor.layout();
      }
    },
    saveCode() {
      // Get current value from editor
      const currentCode = this.editor ? this.editor.getValue() : this.code;
      
      // Emit the updated code
      this.$emit('update:code', currentCode);
      this.$emit('show-message', {
        text: 'Code saved successfully',
        color: 'success'
      });
    }
  },
  watch: {
    language(newLang) {
      if (this.editor && this.monacoInstance) {
        const model = this.editor.getModel();
        this.monacoInstance.editor.setModelLanguage(model, newLang);
      }
    },
    'game.codebase': {
      handler() {
        this.initializeCode();
        if (this.editor) {
          this.editor.setValue(this.code);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
